import React from "react";
import { Label } from "react-bootstrap";
import moment from "moment";
import { IconSVG } from "../Icons/Icons";
import { patientInProtocolStatus, visitStatus } from "../../variables/Enums";
import i18n from "../../i18n";

export const nullableDateFormatter = (day, month, year) => {
  if (!year) return null;

  return `${day ?? "unk"}/${month ? parseInt(month) + 1 : "unk"}/${year}`;
};

export const toLocaleDateFormatter = (date, format, withIcon) => {
  if (!format) format = "DD/MM/YYYY";

  const icon = withIcon ? <IconSVG name="date" /> : null;

  if (!date) return <span className="date-formatter"> </span>;

  try {
    // moment(date).utcOffset() == 0 entonces es UTC.
    // date.length > 30 entonces ya tiene el locale del UI.
    //var localeDate = date.endsWith("Z") || date.length > 30 ? new Date(date) : new Date(date + "Z");
    var localeDate = date.length > 31 ? new Date(date) : new Date(date + "Z");

    //var localeDate = moment(date).utcOffset() != 0 ? new Date(date) : new Date(date + "Z");
    return (
      <span className="date-formatter">
        {icon} {moment(localeDate).format(format)}
      </span>
    );
  } catch (error) {
    return (
      <span className="date-formatter">
        {icon} {moment(date).format(format)} UTC
      </span>
    );
  }
};

export const dateFormatter = (dateTime, format, withIcon) => {
  if (!format) format = "DD/MM/YYYY";

  const icon = withIcon ? <IconSVG name="date" /> : null;

  if (dateTime) {
    return (
      <span className="date-formatter">
        {icon} {moment(dateTime).locale("es").format(format)}{" "}
      </span>
    );
  }

  return <span className="date-formatter"> </span>;
};

export const labelFormatter = (value, style) => {
  if (!style) style = "default";
  if (value) return <Label bsStyle={style}>{value}</Label>;

  return null;
};

export function toLocaleDateTimeFormatter(
  dateTime,
  format = "DD/MM/YYYY HH:mm"
) {
  if (!dateTime) return <span className="datetime-formatter"> </span>;

  try {
    var localeDate =
      dateTime.length > 31 ? new Date(dateTime) : new Date(dateTime + "Z");
    return (
      <span className="datetime-formatter">
        {" "}
        {moment(localeDate).format(format)}
      </span>
    );
  } catch (error) {
    console.log(error, dateTime);
    return (
      <span className="datetime-formatter">
        {" "}
        {moment(dateTime).format(format)} UTC
      </span>
    );
  }
}

export const dateTimeFormatter = (dateTime) => {
  if (dateTime)
    return (
      <span className="datetime-formatter">
        {" "}
        {moment(dateTime).format("DD/MM/YYYY HH:mm")}{" "}
      </span>
    );

  return <span className="datetime-formatter"> </span>;
};

export const dateFieldFormatter = (date) => {
    if (!date) return <span className="date-formatter"></span>;

    // Convertir a string si no lo es
    const dateStr = typeof date === "string" ? date : String(date);

    // Verificar que tenga el formato esperado (contiene "/")
    if (dateStr.includes("/")) {
        const [day, month, year] = dateStr.split("/");

        if (!day || !month || !year || month === "UNK" || isNaN(parseInt(month, 10))) {
            return <span className="date-formatter">{dateStr}</span>;
        }

        const formattedDay = day.padStart(2, "0");
        const formattedMonth = String(parseInt(month, 10) + 1).padStart(2, "0");

        return <span className="date-formatter">{`${formattedDay}/${formattedMonth}/${year}`}</span>;
    }

    // ISO u otros valores sin "/" (ej. auditoría: 2026-03-18T00:00:00) → solo fecha
    const m = moment(date);
    if (m.isValid()) {
        return (
            <span className="date-formatter">
                {m.locale("es").format("DD/MM/YYYY")}
            </span>
        );
    }

    return <span className="date-formatter">{dateStr}</span>;
};

export const dateUTCFormatter = (dateTime, format) => {
  if (!format) format = "DD/MM/YYYY";

  if (dateTime)
    return (
      <span className="date-formatter">
        {" "}
        {moment.utc(dateTime).local().locale("es").format(format)}{" "}
      </span>
    );

  return <span className="date-formatter"> </span>;
};

export const dateTimeUTCFormatter = (dateTime) => {
  if (dateTime)
    return (
      <span className="datetime-formatter">
        {" "}
        {moment.utc(dateTime).local().format("DD/MM/YYYY HH:mm")}{" "}
      </span>
    );

  return <span className="datetime-formatter"> </span>;
};

export const timeFormatter = (time) => {
  if (time)
    return (
      <span className="datetime-formatter">
        {" "}
        {moment(time).format("HH:mm")}{" "}
      </span>
    );

  return <span className="datetime-formatter"> </span>;
};

export const boolFormatter = (value, translationFn) => {
  if (value === null || value === undefined || !translationFn) return "";

  if (value === true) return translationFn("commons.yes");
  if (value === false) return translationFn("commons.no");

  return "";
};

export const yesNoFormatter = (value, translationFn) => {
  if (value === null || value === undefined || !translationFn) return "";

  if (value === "yes" || value) return translationFn("commons.yes");

  return translationFn("commons.no");
};

export const yesNoNotApplyFormatter = (value, translationFn) => {
  if ((value === null && value === undefined) || !translationFn) return "";

  switch (value) {
    case "yes":
      return translationFn("commons.yes");
    case "no":
      return translationFn("commons.no");
    case "n/a":
      return translationFn("commons.na");
    default:
      return "";
  }
};

export const YesNoFormatter = (cell, _row, _rowIndex, formatExtraData) => {
  return (
    <div>
      {cell === true
        ? formatExtraData.t("commons.yes")
        : formatExtraData.t("commons.no")}
    </div>
  );
};

export const objectFormatter = (value) => {
  if (value === null || value === undefined) return "";

  if (value.hasOwnProperty("ConceptId")) {
    return value["Description"];
  }
  if (value.hasOwnProperty("Code")) {
    return value["Title"];
  }

  return "";
};

export const attachmentFormatter = (value) => {
  if (value === null || value === undefined) return "";

  if (value.hasOwnProperty("FileName")) {
    return value["FileName"];
  }
  if (value.hasOwnProperty("ValidatedBy")) {
    return "Validado";
  }

  return "";
};

export const extractContentFromHTML = (html) => {
  return new DOMParser().parseFromString(html, "text/html").documentElement
    .textContent;
};

// Los valores de fecha en auditoría vienen como "D/M/YYYY" (mes 0-indexado) o con "UNK"
// en el día y/o el mes cuando el dato es desconocido (ej: "UNK/9/2026", "UNK/UNK/2026").
// Cualquier otro texto (no es una fecha) debe quedar intacto.
const AUDIT_DATE_PATTERN = /^(UNK|\d{1,2})\/(UNK|\d{1,2})\/(\d{4})$/i;

export const shiftAuditDateMonth = (value) => {
  if (value === null || value === undefined) return value;

  const str = typeof value === "string" ? value : String(value);
  const match = str.match(AUDIT_DATE_PATTERN);
  if (!match) return str;

  const [, day, month, year] = match;
  if (/^unk$/i.test(month)) return str;

  return `${day}/${parseInt(month, 10) + 1}/${year}`;
};

export const visitStatusFormatter = (status) => {
  if (status === null || status === undefined) return "";

  switch (status) {
    case visitStatus.Started:
      return (
        <Label bsStyle="info">{i18n.t("protocols.visit.status.started")}</Label>
      );
    case visitStatus.Completed:
      return (
        <Label bsStyle="success">
          {i18n.t("protocols.visit.status.completed")}
        </Label>
      );
    case visitStatus.Skipped:
      return (
        <Label bsStyle="warning">
          {i18n.t("protocols.visit.status.skipped")}
        </Label>
      );
    case visitStatus.Failed:
      return (
        <Label bsStyle="danger">
          {i18n.t("protocols.visit.status.failed")}
        </Label>
      );
    case visitStatus.Changed:
      return (
        <Label bsStyle="warning">
          {i18n.t("protocols.visit.status.changed")}
        </Label>
      );
    case visitStatus.AutoCompleted:
      return (
        <Label className="montoto">
          {i18n.t("protocols.visit.status.autoCompleted")}
        </Label>
      );
    default:
      return "";
  }
};

export const patientVisitStatusFormatter = (status) => {
  if (status === null || status === undefined) return "";

  switch (status) {
    case patientInProtocolStatus.Screening:
      return (
        <Label bsStyle="info">
          {i18n.t("protocols.patient.statuses.screening")}
        </Label>
      );
    case patientInProtocolStatus.Random:
      return (
        <Label bsStyle="success">
          {i18n.t("protocols.patient.statuses.random")}
        </Label>
      );
    case patientInProtocolStatus.Treatment:
      return (
        <Label bsStyle="success">
          {i18n.t("protocols.patient.statuses.treatment")}
        </Label>
      );
    case patientInProtocolStatus.FollowUp:
      return (
        <Label bsStyle="success">
          {i18n.t("protocols.patient.statuses.followUp")}
        </Label>
      );
    case patientInProtocolStatus.Failed:
      return (
        <Label bsStyle="danger">
          {i18n.t("protocols.patient.statuses.failed")}
        </Label>
      );
    case patientInProtocolStatus.LostToFollowUp:
      return (
        <Label bsStyle="danger">
          {i18n.t("protocols.patient.statuses.lostToFollowUp")}
        </Label>
      );
    case patientInProtocolStatus.WithoutDrugs:
      return (
        <Label bsStyle="info">
          {i18n.t("protocols.patient.statuses.withoutDrugs")}
        </Label>
      );
    case patientInProtocolStatus.Discontinuation:
      return (
        <Label bsStyle="danger">
          {i18n.t("protocols.patient.statuses.discontinuation")}
        </Label>
      );
    case patientInProtocolStatus.EndParticipationInProtocol:
      return (
        <Label bsStyle="info">
          {i18n.t("protocols.patient.statuses.endParticipationInProtocol")}
        </Label>
      );
    default:
      return "";
  }
};

export const protocolStatusFormatter = (status) => {
  if (status === null || status === undefined) return "";

  const match = status.match(/\[(.*?)\]/);
  const propertyName = match ? match[1] : "";

  return i18n.t(`clinicalTrials.statuses.${propertyName}`);
};
